<script setup lang="ts">
import type { AppliedFilters } from '@/components/distiller/types';

import CreateCustomReport from './CreateCustomReport.vue';
import Fieldset from '@/components/fieldset/Fieldset.vue';
import SchoolKpiReportFiltersForm from '@/domains/reports/components/form/SchoolKpiReportFiltersForm.vue';
import StepContainer from '@/components/stepContainer/StepContainer.vue';
import StepFooter from '@/components/stepContainer/StepFooter.vue';

const props = defineProps<{
  studentGrades: App.Base.Data.EnumData[];
  customReport: App.Reports.Data.CustomReportData;
  globalDistiller: App.Search.Data.DistillerData;
  filters: AppliedFilters;
  columnFilters: AppliedFilters;
  columns: string[];
  reportTemplate?: App.Reports.Data.ReportTemplateData;
}>();

const nextForm = useForm({
  url: route('custom-reports.columns.create', { customReport: props.customReport.id }),
  key: `custom-reports.filters.next.${props.customReport.id}`,
  fields: {
    filters: props.filters ?? {
      student_grade: null,
      program_id: null,
      school_ids: []
    },
    columns: props.columns ?? [],
    column_filters: props.columnFilters,
    report_template_id: props.reportTemplate?.id ?? null
  }
});
</script>


					<script lang="ts">
					import __hybridly_layout_0 from '~/resources/layouts/default.vue';
					export default { layout: [__hybridly_layout_0] }
					</script>
					<template>
				
  <CreateCustomReport :currentStep="0" :customReport="customReport">
    <StepContainer title="Create New School KPI Report">
      <div class="mx-auto w-full max-w-xl space-y-10">
        <Fieldset title="Report filters">
          <SchoolKpiReportFiltersForm :form="nextForm" :grades="studentGrades" />
        </Fieldset>

        <StepFooter
          :isLoading="nextForm.processing"
          previousButtonLabel="Cancel"
          nextButtonLabel="Next"
          @next="nextForm.submit()"
          @previous="router.get(route('report-templates.index'))"
        />
      </div>
    </StepContainer>
  </CreateCustomReport>
</template>
